import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import { Box, Container, Typography, useMediaQuery } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import _ from 'lodash'
import React, { useEffect } from 'react'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, BarChart, Bar } from 'recharts'

import { getChartObd, resetChartObd } from '../../store/devices'
const ChartEngineScreen = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch<Dispatch<any>>()

  const ChartObd = useSelector(getChartObd)
  // تابع تبدیل تاریخ شمسی به میلادی
  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }

  const a = ChartObd?.data?.map((p: any) => {
    return { dateTime: shamsi(p.data.dateTime), مقدار: p.data.value, top: 200 }
  })
  const matches = useMediaQuery('(min-width:600px)')
  useEffect(() => {
    return () => {
      dispatch(resetChartObd)
    }
  }, [])
  return (
    <Container fixed maxWidth='sm'>
      <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2, direction: 'ltr' }}>
        <ArrowBackRoundedIcon
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: 'red',
            borderRadius: '50%',
            color: '#fff',
            cursor: 'pointer',
          }}
        />
        <img alt='Logo' src='images/TinyLogo.png' />
      </Box>
      <Box display='flex' justifyContent='center'>
        <Typography>{location.state.title}</Typography>
      </Box>
      <div dir='ltr'>
        <LineChart
          data={a}
          height={300}
          // margin={{ top: 5, right: 10, bottom: 5, left: 0 }}
          width={matches ? 380 : 320}
        >
          <Line dataKey='مقدار' stroke='#8884d8' type='monotone' />
          <CartesianGrid stroke='#ccc' strokeDasharray='5 5' />
          <XAxis dataKey='dateTime' />
          <YAxis />
          <Tooltip />
        </LineChart>
      </div>
    </Container>
  )
}

export default ChartEngineScreen
